import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { getAuthState, getTenantState } from '../../store/selectors';
import {
  handleFederatedSignIn,
  getSocialIcon,
  socialLoginIcons,
} from './authUtil';
import TenantFederation from './TenantFederation';

function SSOLogin(props) {
  const { t } = useTranslation();
  const primaryBackground = props.primaryBackground;

  const tenantName = props.tenant && props.tenant.name; // && props.tenant.name.toUpperCase();

  const onFederatedLoginClick = () => {
    props.handleFederatedSignIn(tenantName);
  };

  const handleSocialLogin = (loginProvider) => {
    props.handleFederatedSignIn(loginProvider);
  };

  const registerSocialIconClass = 'login-social-icon';

  const getSocialIcons = () => {
    const iconList = socialLoginIcons.map((eachIcon) => {
      return getSocialIcon(
        handleSocialLogin,
        eachIcon,
        registerSocialIconClass
      );
    });

    return iconList;
  };

  const federeatedSignInTenantText = {
    ASU: 'my ASURITE',
    SMC: 'SMC',
    BAOBAB: 'Baobab',
  };

  const buttonText = t('Login with {{signOnProvider}}', {
    signOnProvider: federeatedSignInTenantText[tenantName.toUpperCase()],
  });

  return (
    <div
      className={classNames({
        'sso-login-container': true,
        'sso-login-container__baobab': props.tenant.name === 'Baobab',
      })}
    >
      {props.tenantHasSSO && (
        <TenantFederation
          onFederatedLoginClick={onFederatedLoginClick}
          buttonText={buttonText}
          primaryBackground={primaryBackground}
          className={props.className}
          additionalClassName="federated-login-button"
          provider={tenantName}
        />
      )}
      {props.tenant.name !== 'Baobab' && (
        <>
          <p
            className={classNames({
              'sso-login-text': true,
              'social-sso-only': !props.tenantHasSSO,
            })}
          >
            {t('Login with Social')}
          </p>
          <div className="social-login-list">{getSocialIcons()}</div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);
  const auth = getAuthState(state);

  return { tenant, auth };
};

const mapDispatchToProps = {
  handleFederatedSignIn,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SSOLogin)
);
